import * as React from 'react';
import { Link, useLocation, useHistory, RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../helpers/axios';
// import Box from '@mui/material/Box';
// import Drawer from '@mui/material/Drawer';
import LogoWhite from '../assets/logo-white.png';
import VGLogoWhite from '../assets/vg-logo-white.png';

import i18n from '../i18n/config';

import { AppBar, Box, CssBaseline, Divider, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, Toolbar, Typography, Grid, Button, Menu, MenuItem, Autocomplete, TextField, FormControl, Checkbox, Popper, styled, ClickAwayListener, AutocompleteCloseReason, InputLabel, Select, OutlinedInput, SelectChangeEvent, Chip, ListItemButton, Collapse, FormGroup, FormControlLabel, Stack } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import FormatIndentIncreaseOutlinedIcon from '@mui/icons-material/FormatIndentIncreaseOutlined';
import FormatIndentDecreaseOutlinedIcon from '@mui/icons-material/FormatIndentDecreaseOutlined';
import { HomeOutlined, Settings, MenuOpenOutlined, HomeWorkOutlined, LocalShippingOutlined, PeopleOutlined, CreditCardOutlined, FormatListBulletedOutlined, PersonOutlined, LayersOutlined, KeyboardArrowDownOutlined, PowerSettingsNewOutlined, MailOutlined, Assessment, CheckBoxOutlineBlank, CheckBox, ExpandLess, ExpandMore, StarBorder, StarBorderOutlined } from '@mui/icons-material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { findAllByTestId } from '@testing-library/react';
// import SettingsIcon from '@mui/icons-material/Settings';
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 6 + 8,
      width: 250,
    },
  },
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const drawerWidth = 0;

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window_prop?: () => Window;
}

export interface IProps {
  user: {
    id: number;
    name: string;
    email: string;
    role: string;
    is_active: boolean;
    selectedHierarchies: any[];
    selectedHierarchyIds: any[];
  };
  handleHierarchiesSelection: any;
  collapseDrawer: any;
}

export interface IState {
  mobileOpen: boolean;
  desktopOpen: boolean;
  anchorEl: any;
  currectLanguage: string;
  hierarchies: any;
  openAlert: boolean;
  openNeighbourhood: boolean;
  openOperation: boolean;
  openPayments: boolean;
  openDiversion: boolean;
  openReports: boolean;
  openSettings: boolean;
  selectedHierarchies: any[];
  selectedHierarchyIds: any[];
  citySelectionOpen: boolean;
  drawerWidth: any;
  vgPortalURL: string;
  // internalHierarchyIds: any[];
  internalHierarchyIdsWithAlerts: any[];
  internalHierarchyIdsWithLeads: any[];
}

class Nav extends React.Component<RouteComponentProps<any> & IProps & Props, IState> {
  constructor(props: RouteComponentProps & IProps & Props) {
    super(props);
    this.state = {
      mobileOpen: false,
      desktopOpen: true,
      anchorEl: null,
      currectLanguage: 'ENG',
      hierarchies: [],
      openAlert: false,
      openNeighbourhood: false,
      openOperation: false,
      openPayments: false,
      openDiversion: false,
      openReports: false,
      openSettings: false,
      selectedHierarchies: this.props.user.selectedHierarchies,
      selectedHierarchyIds: this.props.user.selectedHierarchyIds,
      citySelectionOpen: false,
      drawerWidth: 240,
      vgPortalURL: 'https://vg-masterv2.bintix.com',
      // internalHierarchyIds: ['1', '2', '3', '4', '5', '6'],
      internalHierarchyIdsWithAlerts: ['1', '2', '3', '4', '5', '6', '7', '11', '12', '13', '14', '15', '16', '17', '18'],
      internalHierarchyIdsWithLeads: ['1', '2', '3', '4', '5', '6']
    }
  }

  public componentDidMount(): void {
    setTimeout(() => {
      this.setState({
        selectedHierarchies: this.props.user.selectedHierarchies,
        selectedHierarchyIds: this.props.user.selectedHierarchyIds
      });
    }, 1000);
    this.fetchAccessibleHierarchiesList();
  }

  public fetchAccessibleHierarchiesList() {
    axios.get(`accessibleHierarchiesList`).then(response => {
      let hierarchies: any = [];
      // hierarchies[0] = {id: 0, name: "Select All"}
      if (response.data.success) {
        response.data.data.map((hierarchy: any) => {
          hierarchies[hierarchy.id] = hierarchy;
        });
      }
      this.setState({ hierarchies: hierarchies });
      // console.log("hierarchies", this.state.hierarchies);
    })
  }

  public render() {
    const { window_prop ,user} = this.props;
    let current_path = this.props.location.pathname.split('/');
    const open = Boolean(this.state.anchorEl);

    const datalabsAdminAllowedPaths = ['diversion', 'incoming-waste', 'diverted-waste', 'outgoing-waste','buyers' ];
    const badBagManagerAllowedPaths = ['/reports/bad-bag-report'];  // add allowed paths here
    const basePath = current_path[1];
    const fullPath = this.props.location.pathname;
    if (this.props.user.role === 'warehouse_manager' && !datalabsAdminAllowedPaths.includes(basePath)) {
      return <Redirect to="/diversion" />;
    }
    if (this.props.user.role === 'bad_bag_manager' && !badBagManagerAllowedPaths.some(path => fullPath.startsWith(path))) {
        return <Redirect to="/reports/bad-bag-report" />;
    }

    const handleDrawerToggle = () => {
      this.setState({ mobileOpen: !this.state.mobileOpen });
    };

    const handleDesktopDrawerToggle = () => {
      this.setState({ desktopOpen: !this.state.desktopOpen });
      if (this.state.drawerWidth != 0) {
        this.props.collapseDrawer(0);
        this.setState({ drawerWidth: 0 });
      } else {
        this.props.collapseDrawer(240);
        this.setState({ drawerWidth: 240 });
      }
    }

    const handleLogout = () => {
      localStorage.clear();
      window.location.reload();
    };

    const handleLanguageSelection = (event: React.MouseEvent<HTMLElement>) => {
      this.setState({ anchorEl: event.currentTarget });
    };

    const selectLanguage = (lang: any) => {
      i18n.changeLanguage(lang.key);
      this.setState({ anchorEl: null, currectLanguage: lang.text });
    };

    const handleHierarchyChange = (event: SelectChangeEvent<string[]>) => {
      const {
        target: { value },
      } = event;
      let selectedIds: any = typeof value === 'string' ? value.split(',') : value;
      let selectedItems: any = [];
      selectedIds.map((hierarchy_id: any) => {
        selectedItems.push(this.state.hierarchies[hierarchy_id]);
      });
      this.setState({
        selectedHierarchyIds: selectedIds,
        selectedHierarchies: selectedItems
      });
      // this.props.handleHierarchiesSelection(selectedItems);
    };

    const handleExpandAlerts = () => {
      this.setState({
        openAlert: !this.state.openAlert,
        openNeighbourhood: false,
        openOperation: false,
        openPayments: false,
        openDiversion: false,
        openReports: false,
        openSettings: false,
      })
    }

    const handleExpandNeighbourhoo = () => {
      this.setState({
        openAlert: false,
        openNeighbourhood: !this.state.openNeighbourhood,
        openOperation: false,
        openPayments: false,
        openDiversion: false,
        openReports: false,
        openSettings: false,
      })
    }

    const handleExpandOperations = () => {
      this.setState({
        openAlert: false,
        openNeighbourhood: false,
        openOperation: !this.state.openOperation,
        openPayments: false,
        openDiversion: false,
        openReports: false,
        openSettings: false,
      })
    }

    const handleExpandPayments = () => {
      this.setState({
        openAlert: false,
        openNeighbourhood: false,
        openOperation: false,
        openPayments: !this.state.openPayments,
        openDiversion: false,
        openReports: false,
        openSettings: false,
      })
    }

    const handleExpandDiversion = () => {
      this.setState({
        openAlert: false,
        openNeighbourhood: false,
        openOperation: false,
        openPayments: false,
        openDiversion: !this.state.openDiversion,
        openReports: false,
        openSettings: false,
      })
    }

    const handleExpandReports = () => {
      this.setState({
        openAlert: false,
        openNeighbourhood: false,
        openOperation: false,
        openPayments: false,
        openDiversion: false,
        openReports: !this.state.openReports,
        openSettings: false,
      })
    }

    const handleExpandSettings = () => {
      this.setState({
        openAlert: false,
        openNeighbourhood: false,
        openOperation: false,
        openPayments: false,
        openDiversion: false,
        openReports: false,
        openSettings: !this.state.openSettings
      })
    }

    const handleSelectAllCities = (e: any) => {
      let selectedIds: any = [];
      let selectedItems: any = [];
      if (e.target.checked) {
        this.state.hierarchies.map((hierarchy: any) => {
          selectedIds.push(hierarchy.id);
          selectedItems.push(hierarchy);
        });
      }
      this.setState({
        selectedHierarchyIds: selectedIds,
        selectedHierarchies: selectedItems
      });
    }

    const drawer = (
      <div className='bg-dark text-white' style={{ height: '500%' }}>
        <Toolbar className={(window.location.origin == this.state.vgPortalURL) ? 'bg-gray' : ''}>
          <Grid className='text-center'>
            <Link to={`/`} style={{ textDecoration: 'none' }}>
              <img src={(window.location.origin == this.state.vgPortalURL) ? VGLogoWhite : LogoWhite} alt='Logo' className='img-fluid' style={{ padding: '20px' }} />
            </Link>
          </Grid>
        </Toolbar>
        <Divider />
        <List>
           {this.props.user.role ? (this.props.user.role === 'warehouse_manager' ? (
    // Only "Material Management" menu for warehouse_manager
    <>
      <ListItemButton
        className='link'
        onClick={() => handleExpandDiversion()}
        key={i18n.t('Diversion').toString()}
        selected={['diversion', 'incoming-waste', 'diverted-waste', 'outgoing-waste', 'buyers', 'incoming-waste-charts', 'diverted-waste-charts', 'outgoing-waste-charts'].includes(current_path[1])}
      >
        <ListItemIcon className='text-white'>
          <FormatListBulletedOutlined />
        </ListItemIcon>
        <ListItemText primary={i18n.t('Material Management')} />
        {this.state.openDiversion ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={this.state.openDiversion} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            sx={{ pl: 4 }}
            className='link'
            component={Link}
            to="/diversion"
            selected={current_path[1] === 'diversion'}
          >
            <ListItemText primary="Overview" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 4 }}
            className='link'
            component={Link}
            to="/incoming-waste"
            selected={current_path[1] === 'incoming-waste'}
          >
            <ListItemText primary="Input Waste" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 4 }}
            className='link'
            component={Link}
            to="/diverted-waste"
            selected={current_path[1] === 'diverted-waste'}
          >
            <ListItemText primary="Sorted Waste" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 4 }}
            className='link'
            component={Link}
            to="/outgoing-waste"
            selected={current_path[1] === 'outgoing-waste'}
          >
            <ListItemText primary="Outgoing Waste" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 4 }}
            className='link'
            component={Link}
            to="/buyers"
            selected={current_path[1] === 'buyers'}
          >
            <ListItemText primary="Buyers" />
          </ListItemButton>
        </List>
      </Collapse>
    </>
     ) : this.props.user.role === 'bad_bag_manager' ? (
      // bad_bag_manager menu only reports with bad-bag-report
      <>
        <ListItemButton
          className='link'
          onClick={() => handleExpandReports()}
          key={i18n.t('Reports').toString()}
          selected={['bad-bag-report'].includes(current_path[2])}
        >
          <ListItemIcon className='text-white'>
            <Assessment />
          </ListItemIcon>
          <ListItemText primary={i18n.t('Reports')} />
          {this.state.openReports ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={this.state.openReports} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 4 }}
              className='link'
              component={Link}
              to="/reports/bad-bag-report"
              selected={current_path[2] === 'bad-bag-report'}
            >
              <ListItemText primary="Bad Bag Report" />
            </ListItemButton>
          </List>
        </Collapse>
      </>
  ) : (
    <>
          <ListItemButton className='link' component={Link} to="/" key={i18n.t("Home").toString()} selected={current_path[1] === ''}>
            <ListItemIcon className='text-white'>
              <HomeOutlined />
            </ListItemIcon>
            <ListItemText primary={i18n.t("Home")} />
          </ListItemButton>
          {
            Object.keys(this.state.hierarchies).some((item: any) => this.state.internalHierarchyIdsWithAlerts.includes(item)) &&
            <>
              <ListItemButton className='link' onClick={() => handleExpandAlerts()} key={i18n.t("Alerts").toString()} selected={['alerts', 'notifications', 'surveys'].includes(current_path[1])}>
                <ListItemIcon className='text-white'>
                  <MailOutlined />
                </ListItemIcon>
                <ListItemText primary={i18n.t("Alerts")} />
                {this.state.openAlert ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={this.state.openAlert} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/alerts" selected={current_path[1] == 'alerts'}>
                    <ListItemText primary="Offers" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/notifications" selected={current_path[1] == 'notifications'}>
                    <ListItemText primary="Notifications" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/surveys" selected={current_path[1] == 'surveys'}>
                    <ListItemText primary="Surveys" />
                  </ListItemButton>
                </List>
              </Collapse>
            </>
          }

          <ListItemButton className='link' onClick={() => handleExpandNeighbourhoo()} key={i18n.t('Neighbourhood').toString()} selected={['customers', 'customer-leads', 'tickets', 'inactive-registrations', 'community-list', 'pause-pickups'].includes(current_path[2])}>
            <ListItemIcon className='text-white'>
              <HomeWorkOutlined />
            </ListItemIcon>
            <ListItemText primary={i18n.t('Neighbourhood')} />
            {this.state.openNeighbourhood ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={this.state.openNeighbourhood} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/neighbourhood/customers" selected={current_path[2] == 'customers'}>
                <ListItemText primary="Customers" />
              </ListItemButton>
              {
                Object.keys(this.state.hierarchies).some((item: any) => this.state.internalHierarchyIdsWithLeads.includes(item)) &&
                <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/neighbourhood/customer-leads" selected={current_path[2] == 'customer-leads'}>
                  <ListItemText primary="Customer Leads" />
                </ListItemButton>
              }

              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/neighbourhood/tickets" selected={current_path[2] == 'tickets'}>
                <ListItemText primary="Tickets" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/neighbourhood/inactive-registrations" selected={current_path[2] == 'inactive-registrations'}>
                <ListItemText primary="Inactive Registrations" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/neighbourhood/community-list" selected={current_path[2] == 'community-list'}>
                <ListItemText primary="Communities" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/neighbourhood/pause-pickups" selected={current_path[2] == 'pause-pickups'}>
                <ListItemText primary="Pause Pickups" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton className='link' onClick={() => handleExpandOperations()} key={i18n.t('Operations').toString()} selected={['bag-inventory', 'agents', 'batch-pickups', 'bag-distribution', 'community-pickups', 'pickup-points', 'delete-sets', 'maintenance', 'expenses', 'vehicle-maintenance-charts'].includes(current_path[2])}>
            <ListItemIcon className='text-white'>
              <LayersOutlined />
            </ListItemIcon>
            <ListItemText primary={i18n.t('Operations')} />
            {this.state.openOperation ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={this.state.openOperation} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/operations/bag-inventory" selected={current_path[2] == 'bag-inventory'}>
                <ListItemText primary="Bag Inventory" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/operations/agents" selected={current_path[2] == 'agents'}>
                <ListItemText primary="Agents" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/operations/batch-pickups" selected={current_path[2] == 'batch-pickups'}>
                <ListItemText primary="Batch Pickups" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/operations/bag-distribution" selected={current_path[2] == 'bag-distribution'}>
                <ListItemText primary="Bag Distribution" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/operations/community-pickups" selected={current_path[2] == 'community-pickups'}>
                <ListItemText primary="Community Pickups" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/operations/pickup-points" selected={current_path[2] == 'pickup-points'}>
                <ListItemText primary="Pickup Points" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/operations/delete-sets" selected={current_path[2] == 'delete-sets'}>
                <ListItemText primary="Delete Sets Permanantly" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton className='link' onClick={() => handleExpandPayments()} key={i18n.t('Payments').toString()} selected={['payments-for-review', 'bag-weights-for-review', 'transactions-pending-approval'].includes(current_path[2])}>
            <ListItemIcon className='text-white'>
              <CreditCardOutlined />
            </ListItemIcon>
            <ListItemText primary={i18n.t('Payments')} />
            {this.state.openPayments ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={this.state.openPayments} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/payments/payments-for-review" selected={current_path[2] == 'payments-for-review'}>
                <ListItemText primary="Payments For Review" />
              </ListItemButton>
              <ListItemButton
                  sx={{ pl: 4 }}
                  className='link'
                  component={Link}
                  to="/payments/bag-weights-for-review"
                  selected={current_path[2] == 'bag-weights-for-review'}
              >
                  <ListItemText primary="Bag Weights For Review" />
              </ListItemButton>
              {
                (["vijay@bintix.com", "kedarnath@bintix.com", "satheesh@bintix.com"].includes(this.props.user.email)) &&
                <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/payments/transactions-pending-approval" selected={current_path[2] == 'transactions-pending-approval'}>
                  <ListItemText primary="Transactions Pending Approval" />
                </ListItemButton>
              }
              {/* <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/payments" selected={current_path[1] == 'payments'}>
                <ListItemText primary="Payments" />
              </ListItemButton> */}
            </List>
          </Collapse>

          <ListItemButton className='link' onClick={() => handleExpandDiversion()} key={i18n.t('Diversion').toString()} selected={['diversion', 'incoming-waste', 'diverted-waste', 'outgoing-waste', 'incoming-waste-charts', 'diverted-waste-charts', 'outgoing-waste-charts'].includes(current_path[1])}>
            <ListItemIcon className='text-white'>
              <FormatListBulletedOutlined />
            </ListItemIcon>
            <ListItemText primary={i18n.t('Diversion')} />
            {this.state.openDiversion ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={this.state.openDiversion} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/diversion" selected={current_path[1] == 'diversion'}>
                <ListItemText primary="Overview" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/incoming-waste" selected={current_path[1] == 'incoming-waste'}>
                <ListItemText primary="Incoming Waste" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/diverted-waste" selected={current_path[1] == 'diverted-waste'}>
                <ListItemText primary="Diverted Waste" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/outgoing-waste" selected={current_path[1] == 'outgoing-waste'}>
                <ListItemText primary="Outgoing Waste" />
              </ListItemButton>
              {
               (process.env.REACT_APP_INVENTORY_ALLOWED_EMAIL?.split(',') || []).includes(this.props.user.email) && (
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/inventory" selected={current_path[1] == 'inventory'}>
                <ListItemText primary="Inventory" />
              </ListItemButton>
               )
              }
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/buyers" selected={current_path[1] == 'buyers'}>
                <ListItemText primary="Buyers" />
              </ListItemButton>
            </List>
          </Collapse>

          <ListItemButton className='link' onClick={() => handleExpandReports()} key={i18n.t('Reports').toString()} selected={['community-report', 'city-report', 'bad-bag-report', 'odd-bag-report'].includes(current_path[2])}>
            <ListItemIcon className='text-white'>
              <Assessment />
            </ListItemIcon>
            <ListItemText primary={i18n.t('Reports')} />
            {this.state.openReports ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={this.state.openReports} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/reports/community-report" selected={current_path[2] == 'community-report'}>
                <ListItemText primary="Community Report" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/reports/city-report" selected={current_path[2] == 'city-report'}>
                <ListItemText primary="City Report" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/reports/bad-bag-report" selected={current_path[2] == 'bad-bag-report'}>
                <ListItemText primary="Bad Bag Report" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/reports/odd-bag-report" selected={current_path[2] == 'odd-bag-report'}>
                <ListItemText primary="Odd Bag Report" />
              </ListItemButton>
              {
                 (["vijay@bintix.com", "kedarnath@bintix.com", "satheesh@bintix.com"].includes(this.props.user.email)) &&
                 <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/reports/balance-sheet" selected={current_path[2] == 'balance-sheet'}>
                <ListItemText primary=" Balance Sheet" />
                 </ListItemButton>
              } 
            </List>
          </Collapse>

          {/* <ListItemButton className='link' onClick={() => handleExpandSettings()} key={i18n.t('Settings').toString()} selected={['constants', 'sms-template', 'acceptance-stat'].includes(current_path[2])}>
            <ListItemIcon className='text-white'>
              <Settings />
            </ListItemIcon>
            <ListItemText primary={i18n.t('Settings')} />
            {this.state.openSettings ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={this.state.openSettings} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/settings/constants" selected={current_path[2] == 'constants'}>
                <ListItemText primary="Constants" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/settings/sms-template" selected={current_path[2] == 'sms-template'}>
                <ListItemText primary="SMS Template" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} className='link' component={Link} to="/settings/acceptance-stat" selected={current_path[2] == 'acceptance-stat'}>
                <ListItemText primary="Acceptance Stats" />
              </ListItemButton>
            </List>
          </Collapse> */}
          </>
        )
      ):null}
        </List>
      </div>
    );

    const container: any = window_prop !== undefined ? () => window_prop().document.body : undefined;
    return (
      <div>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${this.state.drawerWidth}px)` },
            ml: { sm: `${this.state.drawerWidth}px` },
          }}
          className='bg-gray'
        >
          <Toolbar className='top-nav'>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { xs: 'block', sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            {
              this.state.drawerWidth != 0 ? (<IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDesktopDrawerToggle}
                sx={{ mr: 2, display: { xs: 'none', sm: 'block' }, width: '40px', height: '40px' }}
              >
                <FormatIndentDecreaseOutlinedIcon sx={{ color: 'black' }} />
              </IconButton>) : (<IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDesktopDrawerToggle}
                sx={{ mr: 2, display: { xs: 'none', sm: 'block' }, width: '40px', height: '40px' }}
              >
                <FormatIndentIncreaseOutlinedIcon sx={{ color: 'black' }} />
              </IconButton>)
            }
            <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
              &nbsp;
            </Typography>

            {/* //////////////////////////////////////////////////////////////////// */}

            {/* <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              options={this.state.hierarchies}
              disableCloseOnSelect
              isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
              getOptionLabel={(option: any) => option.name}
              onChange={(value: any, newValue: any) => handleHierarchyChange(newValue)}
              value={this.props.user.selectedHierarchies}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={option && option.all ? this.props.user.selectedHierarchies.length === this.state.hierarchies.slice(1).length : selected}
                  />
                  {option.name}
                </li>
              )}
              style={{ width: 500 }}
              renderInput={(params) => (
                <TextField {...params} label="Checkboxes" placeholder="Favorites" />
              )}
            /> */}

            {/* //////////////////////////////////////////////////////////////////// */}
            <FormControl sx={{ m: 1, minWidth: '30%', maxWidth: '40%' }}>
              <InputLabel id="demo-multiple-checkbox-label">Cities</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={this.state.selectedHierarchyIds}
                open={this.state.citySelectionOpen}
                onOpen={() => this.setState({ citySelectionOpen: true })}
                onChange={handleHierarchyChange}
                input={<OutlinedInput label="Cities" />}
                renderValue={(selected) => (<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.slice(0, 3).map((value: any) => {
                    value = this.state.hierarchies[value];
                    if (value) {
                      return (<Chip key={'slected_hierarchy_' + value?.id} label={value?.name} />);
                    }
                  })}
                  {selected.length > 3 && <Typography style={{ marginTop: '4px' }}>{" +"}{selected.length - 3}</Typography>}
                </Box>)}
                MenuProps={MenuProps}
              >
                {/* <MenuItem key={'hierarchy_' + 0} value={0}>
                    <Checkbox key={'hierarchy_checkbox_' + 0} value={0} checked={this.props.user.selectedHierarchyIds.includes(0)} />
                    <ListItemText key={'hierarchy_checkbox_label_' + 0} primary={'All'} />
                  </MenuItem> */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', margin: '2px 28px' }}>
                  <FormControlLabel control={
                    <Checkbox
                      checked={this.state.selectedHierarchyIds.length === Object.keys(this.state.hierarchies).length}
                      indeterminate={this.state.selectedHierarchyIds.length > 0 && this.state.selectedHierarchyIds.length < Object.keys(this.state.hierarchies).length}
                      onChange={handleSelectAllCities}
                    />
                  } label="All" />
                </Box>
                {
                  this.state.hierarchies.map((ele: any) => (
                    <MenuItem key={'hierarchy_' + ele.id} value={ele.id}>
                      <Checkbox key={'hierarchy_checkbox_' + ele.id} value={ele.id} checked={this.state.selectedHierarchyIds.includes(ele.id)} />
                      <ListItemText key={'hierarchy_checkbox_label_' + ele.id} primary={ele.name} />
                    </MenuItem>
                  ))
                }
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', m: 1 }}>
                  <Stack spacing={2} direction="row">
                    <Button className='customCloseButton' onClick={() => this.setState({
                      citySelectionOpen: false,
                      selectedHierarchies: this.props.user.selectedHierarchies,
                      selectedHierarchyIds: this.props.user.selectedHierarchyIds
                    })}>Close</Button>
                    <Button onClick={() => this.setState({ citySelectionOpen: false }, () => this.props.handleHierarchiesSelection(this.state.selectedHierarchies))} variant="contained" color="primary">
                      Apply
                    </Button>
                  </Stack>
                </Box>
              </Select>
            </FormControl>

            <Button className="text-capitalize nav-btn" onClick={() => this.props.history.push('/profile')}>{this.props.user.name} <PersonOutlined /></Button>
            {/* <Divider orientation="vertical" flexItem />
            <Button id="lang-button" className='nav-btn' sx={{ color: '#36204d', lineHeight: '20px', size: '16px' }} onClick={(e: any) => handleLanguageSelection(e)}>{this.state.currectLanguage} <KeyboardArrowDownOutlined /></Button>
            <Menu
              id="lang-menu"
              aria-labelledby="lang-button"
              anchorEl={this.state.anchorEl}
              open={open}
              onClose={() => this.setState({ anchorEl: null })}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <MenuItem onClick={() => selectLanguage({ 'key': 'en', 'text': 'ENG' })}>ENG</MenuItem>
              <MenuItem onClick={() => selectLanguage({ 'key': 'es', 'text': 'SPA' })}>SPA</MenuItem>
            </Menu> */}
            <Divider orientation="vertical" flexItem />
            <Button className="text-capitalize nav-btn" onClick={() => handleLogout()}>Logout <PowerSettingsNewOutlined /></Button>
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{ width: { sm: this.state.drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={this.state.mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="persistent"
            open={this.state.desktopOpen}
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: this.state.drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
      </div>
    );
  }
}
export default withRouter(Nav);
